import Marionette from "backbone.marionette";

import templ from "../templates/components";

const LoadingView = Marionette.View.extend({
    name: "STEP_LOADING",
    className: "loading-step",
    template: templ.Loading,
    serializeData() {
        return {
            title: this.options.title,
            subtitle: this.options.subtitle,
        };
    },
    shouldSkip() {
        return false;
    },
});

export default LoadingView;
